// @flow

import Cookie from 'js-cookie';

export const getParam = (param: string) => {
  const params = new URL(window.location).searchParams;

  if (!params.has(param)) return;

  return params.get(param);
};

export const publicDirectoryPath = (path: string) => {
  return `/uk/originations/public/${path}`;
};

export const roundNumber = (param: number, decimalPlaces: number = 2) => {
  return parseFloat(param.toFixed(decimalPlaces));
};

export const formatInterestRate = (
  interestRate: number,
  monthly: boolean = false,
  decimalPlaces: number = 1
): number => {
  const divider = monthly ? 12 : 1;
  return roundNumber((interestRate / divider) * 100, decimalPlaces);
};

export const sendToLogin = () => {
  /* Removes application id cookie to prevent users from getting stuck in a loop
   when an application is expired. This is due to automatic redirection to loan
   application in eligibility when user has this cookie. */
  Cookie.remove('gpo-application-id');
  window.location.assign('/login');
};

export const formatCurrencyInputOutput = (value) => {
  return parseInt(value.toString().replace(/[^0-9.]/g, ''), 10);
};

export const formatCentsToPounds = (cents) => {
  if (cents == null) {
    return '';
  }
  const pounds = cents / 100;
  return pounds.toLocaleString('en-GB', { style: 'decimal' });
};
